"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.registerStoreUnderBatching = exports.registerStateUnderBatching = exports.isBatching = exports.default = void 0;
var completeStateUpdate_1 = require("./Util/completeStateUpdate");
var completeStoreUpdate_1 = require("./Util/completeStoreUpdate");
var batchingState = {
    isBatching: false,
    stateUnderBatching: null,
    storesUnderBatching: []
};
var updateQueue = [];
var batch = function (invokeConsumerActionBatch) {
    var returnValue;
    try {
        if (batchingState.isBatching) {
            // If a batch was invoked in reaction to an ongoing batch,
            // simply make the changes and return
            return invokeConsumerActionBatch();
        }
        batchingState.isBatching = true;
        returnValue = invokeConsumerActionBatch();
    }
    catch (err) {
        // Ensure the state is reset on consumer-instigated exceptions
        batchingState.isBatching = false;
        throw err;
    }
    if (!batchingState.stateUnderBatching ||
        batchingState.storesUnderBatching.length === 0) {
        batchingState.isBatching = false;
        throw new Error('A call to `batch()` must result in a call to one or more actions');
    }
    var updatedStoreCount = batchingState.storesUnderBatching.length;
    // For each updated store, emit updates for linking stores _before_
    // freezing the store. This ensures that linking updates will trigger
    // the next state and an unresolved (mutable) draft state
    batchingState.storesUnderBatching.forEach(function (store) {
        store.internal$.next(store.value);
    });
    // Freeze the updated stores
    batchingState.storesUnderBatching.forEach(function (store) {
        return (0, completeStoreUpdate_1.default)(store, false);
    });
    // Obtain a list of any linking stores updated as a side-effect of update stores,
    // and ensure updates are emitted from them too
    var updatedLinkingStores = batchingState.storesUnderBatching.slice(updatedStoreCount);
    // Freeze linking stores which have updated
    updatedLinkingStores.forEach(function (store) {
        (0, completeStoreUpdate_1.default)(store);
    });
    batchingState.isBatching = false;
    // Freeze the new top-level state object
    (0, completeStateUpdate_1.default)(batchingState.stateUnderBatching);
    var storesUnderBatching = batchingState.storesUnderBatching, stateUnderBatching = batchingState.stateUnderBatching;
    // Flush state to ensure any reactions happen within
    // a clean state
    batchingState.stateUnderBatching = null;
    batchingState.storesUnderBatching = [];
    // An update queue is implemented to ensure reactions do not
    // get sucked into the batch, and that emissions of any reactions
    // are emitted in the correct order, only after all store and state
    // updates have been broadcast from a batch
    if (updateQueue.length === 0) {
        updateQueue.push({
            storesAndValues: storesUnderBatching.map(function (store) { return [
                store,
                store.value
            ]; }),
            state: stateUnderBatching,
            value: stateUnderBatching.value
        });
        for (var i = 0; i < updateQueue.length; i++) {
            var updateQueueItem = updateQueue[i];
            updateQueueItem.storesAndValues.forEach(function (_a) {
                var store = _a[0], value = _a[1];
                return store.update$.next(value);
            });
            updateQueueItem.state.update$.next(updateQueueItem.value);
            updateQueue.shift();
            i--;
        }
    }
    else {
        updateQueue.push({
            storesAndValues: storesUnderBatching.map(function (store) { return [
                store,
                store.value
            ]; }),
            state: stateUnderBatching,
            value: stateUnderBatching.value
        });
    }
    return returnValue;
};
exports.default = batch;
var isBatching = function () { return batchingState.isBatching; };
exports.isBatching = isBatching;
var registerStoreUnderBatching = function (store) {
    if (batchingState.storesUnderBatching.indexOf(store) < 0) {
        batchingState.storesUnderBatching.push(store);
    }
    else {
        // Store is already represented, and in a draft state.
        // Do not leave in a pending actioning state
        store.isActioning = false;
    }
};
exports.registerStoreUnderBatching = registerStoreUnderBatching;
var registerStateUnderBatching = function (aState) {
    return (batchingState.stateUnderBatching = aState);
};
exports.registerStateUnderBatching = registerStateUnderBatching;
//# sourceMappingURL=batch.js.map